/**
 * Manipulates plain objects and arrays using key prefixes
 * @param  {Object|Array} previousValue Initial object/array
 * @param  {Object|Array} nextValue     Object/array to merge
 * @param  {string}       mergeType     The type of comparison to do
 * @return {Object|Array}               Merged object or array
 */
export default function advancedMerge(previousValue, nextValue, mergeType = 'r') {
  const isArray = (Array.isArray(previousValue) && Array.isArray(nextValue));
  const isObject = (
    (typeof previousValue === 'object') &&
    (typeof nextValue === 'object') &&
    !isArray
  );

  if (!isArray && !isObject) return nextValue;

  if (isArray) {
    switch (mergeType) {
      case '+': {
        return [...previousValue, ...nextValue];
      }

      case '-': {
        return previousValue.filter(item => !nextValue.includes(item));
      }

      default: {
        return nextValue;
      }
    }
  }

  const mergedValues = { ...previousValue };
  Object.keys(nextValue).forEach((key) => {
    const [modifier, name] = /^([+-]?)(.+)/g.exec(key).slice(1);

    switch (modifier) {
      case '+': {
        mergedValues[name] = advancedMerge(previousValue[name], nextValue[key], modifier);
        break;
      }

      case '-': {
        if (Array.isArray(previousValue[name]) && Array.isArray(nextValue[key])) {
          mergedValues[name] = advancedMerge(previousValue[name], nextValue[key], modifier);
        } else {
          delete mergedValues[name];
        }
        break;
      }

      default: {
        mergedValues[name] = nextValue[key];
      }
    }
  });
  return mergedValues;
}
